import type { DashboardSummaryDto, ReportResponse } from "@grizzly/shared";
import { request, requestText } from "../http.js";

export interface ReportQuery {
  from?: string;
  to?: string;
}

export const reportingApi = {
  dashboard: () => request<DashboardSummaryDto>("/reports/dashboard"),
  report: (name: string, params: ReportQuery = {}) =>
    request<ReportResponse>(`/reports/${name}${queryString(params)}`),
  reportCsv: (name: string, params: ReportQuery = {}) => {
    const query = new URLSearchParams();
    query.set("format", "csv");
    if (params.from) query.set("from", params.from);
    if (params.to) query.set("to", params.to);
    return requestText(`/reports/${name}?${query.toString()}`);
  },
};

function queryString(params: ReportQuery): string {
  const query = new URLSearchParams();
  if (params.from) query.set("from", params.from);
  if (params.to) query.set("to", params.to);
  const text = query.toString();
  return text ? `?${text}` : "";
}
